
import { customEvent } from "./customEvent";
import { multilingual_url } from "./multilingual-url";

export const updateCart = async (response, disableSuccess) => {
  if (response) {
    async function getCart() {
      const result = await fetch("/cart.json");
      if (result.status === 200) {
        return result.json();
      }
      throw new Error(`Failed to get request`);
    }

    /* update cart item count */
    const cart = await getCart();
    const itemCountElements = Array.from(document.querySelectorAll('[data-item-count]'));

    itemCountElements.forEach(element => {
      element.innerHTML = cart.item_count
      element.classList.toggle('hide', cart.item_count == 0);
    });

    if(response.description) {
      if(response.status !== 200) {
        window.toast.error({
          message: response.description,
          icon: false
        })
      }
      else {
        if(!disableSuccess) {
          window.dispatchEvent(new Event('added-to-cart'));
        }
      }
    }
    else {
      if(!disableSuccess) {
        window.dispatchEvent(new Event('added-to-cart'));
      }
    }
  }

  customEvent(window, 'ajax-cart', {
    cartSections: response.sections
  });
}

/**
 * Adds an item to cart and updates the cart count
 *
 * @param {String} variantId - variant to add
 * @param {Int} quantity - quantity to add
 */
export const addToCart = async (variantId, quantity) => {
  window.dispatchEvent(new Event('dynamic-cart-loading'));

  const addResponse = await fetch(multilingual_url('/cart/add.js'), {
    method: "POST",
    body: JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: quantity,
          properties: {
            "__time": Date.now()
          }
        }
      ],
      sections: ["cart-main", "header", "announcement-bar"]
    }),
    headers: {
      'Content-Type': "application/json"
    }
  });

  const addResponseJson = await addResponse.json();

  updateCart(addResponseJson);
}

const serializeForm = (form) => {
  return Array.from(
    new FormData(form),
    e => e.map(encodeURIComponent).join('=')
  ).join('&')
}

/**
 * Adds a product to cart from a form
 *
 * @param {HTMLElement} formElement - Product form element
 */
export const addToCartForm = async (formElement, skipAddedToCartDrawer) => {
  window.dispatchEvent(new Event('dynamic-cart-loading'));

  const cartResponse = await fetch(multilingual_url('/cart/add.js'), {
    method: "POST",
    body: serializeForm(formElement) + "&sections[]=cart-main&sections[]=header&sections[]=announcement-bar",
    headers: {
      'Content-Type': "application/x-www-form-urlencoded"
    }
  });

  const cartResponseJson = await cartResponse.json();

  updateCart(cartResponseJson, skipAddedToCartDrawer);
}

/**
 * Change an item's quantity in the cart
 * @param {Int} id - variant id or line item key
 * @param {*} quantity - the new quantity
 */
export const changeCart = async (id, quantity, skipUpdate) => {
  window.dispatchEvent(new Event('dynamic-cart-loading'));

  const changeResponse = await fetch(multilingual_url('/cart/change.js'), {
    method: "POST",
    body: JSON.stringify({
      id,
      quantity,
      sections: ["cart-main", "header", "announcement-bar"]
    }),
    headers: {
      'Content-Type': "application/json"
    }
  });

  const changeResponseJson = await changeResponse.json();

  if (skipUpdate) {
    return;
  }

  updateCart(changeResponseJson, true);
}

/**
 * Change an item's product properties in the cart
 * @param {Int} id - variant id or line item key
 * @param {*} properties - the new properties
 */
 export const changeCartItemProperties = async (id, properties) => {
  window.dispatchEvent(new Event('dynamic-cart-loading'));

  const changeResponse = await fetch(multilingual_url('/cart/change.js'), {
    method: "POST",
    body: JSON.stringify({
      id,
      properties,
      sections: ["cart-main", "header", "announcement-bar"]
    }),
    headers: {
      'Content-Type': "application/json"
    }
  });

  const changeResponseJson = await changeResponse.json();

  updateCart(changeResponseJson, true);
}

export const updateAttributes = async (attributes) => {
  window.dispatchEvent(new Event('dynamic-cart-loading'));

  const updateResponse = await fetch(multilingual_url('/cart/update.js'), {
    method: "POST",
    body: JSON.stringify({
      attributes,
      sections: ["cart-main", "header", "announcement-bar"]
    }),
    headers: {
      'Content-Type': "application/json"
    }
  });

  const updateResponseJson = await updateResponse.json();

  updateCart(updateResponseJson, true);
}

// update note
export const updateNote = async (note) => {
  await fetch(multilingual_url('/cart/update.js'), {
    method: "POST",
    body: JSON.stringify({
      note,
      sections: ["cart-main", "header", "announcement-bar"]
    }),
    headers: {
      'Content-Type': "application/json"
    }
  });
}
